import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.css'],
})
export class ServiceCardComponent {
  @Input() cardTitle: string = '';
  @Input() imgPath!: string;
  @Input() cardIcon: IconProp = faStar;
  @Input() language!: string;
  @Input() data!: any;
  @Input() fileName!: string;

  @ViewChild('carouselTrack') carouselTrack!: ElementRef<HTMLElement>;

  activeIndex = 0;
  isMobile = false;

  private touchStartX = 0;

  ngOnInit(): void {
    this.checkMobile();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  checkMobile(): void {
    this.isMobile = window.innerWidth <= 575;
  }

  goToSlide(index: number): void {
    this.activeIndex = index;
    const track = this.carouselTrack?.nativeElement;
    if (!track) return;

    const slide = track.querySelector('.carousel-slide') as HTMLElement;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + 12; // 12px gap
    track.style.transition = 'transform 0.35s ease';
    // Positive value for RTL (Arabic) layouts — flip sign for LTR
    track.style.transform = `translateX(${index * slideWidth}px)`;
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.touches[0].clientX;
  }

  onTouchMove(event: TouchEvent): void {
    const diff = this.touchStartX - event.touches[0].clientX;
    const track = this.carouselTrack?.nativeElement;
    if (!track) return;

    const slide = track.querySelector('.carousel-slide') as HTMLElement;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + 12;
    const base = this.activeIndex * slideWidth;

    // Disable transition for live drag feel
    track.style.transition = 'none';
    // Positive base for RTL — finger follows drag
    track.style.transform = `translateX(${base - diff}px)`;
  }

  onTouchEnd(event: TouchEvent): void {
    const track = this.carouselTrack?.nativeElement;
    if (track) track.style.transition = 'transform 0.35s ease';

    const diff = this.touchStartX - event.changedTouches[0].clientX;
    const total = this.data?.details?.services?.length ?? 0;

    if (Math.abs(diff) > 40) {
      if (diff < 0 && this.activeIndex < total - 1) {
        // Swiped left → next slide
        this.goToSlide(this.activeIndex + 1);
      } else if (diff > 0 && this.activeIndex > 0) {
        // Swiped right → previous slide
        this.goToSlide(this.activeIndex - 1);
      } else {
        // At boundary — snap back
        this.goToSlide(this.activeIndex);
      }
    } else {
      // Not swiped far enough — snap back
      this.goToSlide(this.activeIndex);
    }
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${object.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
